import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './background-linear-gradient.scss';

const BG_CLASS_NAME = 'bg-cool-gray-90';

export const BackgroundLinearGradient = ({ children, className = '' }) => {
  useEffect(() => {
    document.body.classList.add(BG_CLASS_NAME);

    return () => {
      document.body.classList.remove(BG_CLASS_NAME);
    };
  }, []);

  return <div className={classnames('background-linear-gradient h-100', className)}>{children}</div>;
};

BackgroundLinearGradient.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
